import type { BMSPaginationDTO } from '@/models/dto/bms/bms-pagination-dto'
import type { BMSsWithPagination } from '@/models/types/bms/bms-with-pagination'
import { mapToPagination } from '../pagination-mapper'
import { mapToBMS  } from './bms-mapper'

const mapToBMSs = (dto: BMSPaginationDTO): BMSsWithPagination => {
    return {
        bmss: dto.bms?.map(mapToBMS) ?? undefined,
        pagination: dto.paginationData ? mapToPagination(dto.paginationData) : undefined,
    }
}

export { mapToBMSs }
